import { CRM_BASE_API } from 'modules/crm/api/crm-pipeline-api'
import { ContactNoteInterface } from 'modules/crm/pipeline/contact-card/note/type/contact-note-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import {
  DataWithPaginationInterface,
  SwrPaginationInterface,
} from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWRInfinite from 'swr/infinite'

interface UseContactNotesProps extends SwrPaginationInterface {
  contactId: number | null
  isFetchAllowed: boolean
}

export const getNotesApi = (contactId: number | null) =>
  `${CRM_BASE_API}/contacts/${contactId}/notes`

export const useContactNotes = ({
  contactId,
  isFetchAllowed,
  limit,
  pagination,
}: UseContactNotesProps) => {
  const { user } = useUser()
  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<ContactNoteInterface>
  >({
    method: RequestMethodsEnum.get,
  })

  return useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (!!previousPageData && !previousPageData.hasMore) return null

      if (pageIndex === 0 && isFetchAllowed)
        return `${getNotesApi(contactId)}?${getPaginationQueryString({
          limit,
          pagination,
        })}`

      if (user && isFetchAllowed) {
        return `${getNotesApi(contactId)}?${getPaginationQueryString({
          limit,
          pagination: {
            ...pagination,
            startFromId: (pageIndex - 1) * limit + previousPageData.items.length,
          },
        })}`
      }
    },
    fetcher,
    {
      revalidateAll: true,
    },
  )
}
